import React from 'react';

import { EmailEntry } from '@/src/components/project/Inbox2/types';

import EmailHeadingInput from './EmailHeadingInput/EmailHeadingInput';

import EmailEditor from '../EmailEditor/EmailEditor';

type ComposeEmailFormProps = {
  projectId: string;
  files: FileList | [];
  toRecipients: any[];
  ccRecipients: any[];
  isUploading: boolean;
  isSubmitEnabled: boolean;
  emailSignature: string | null;
  uploaderId: string;
  setToRecipients: (prop: any[]) => void;
  setCcRecipients: (prop: any[]) => void;
  setHasInput: (hasInput: boolean) => void;
  setIsUploading: (isUploading: boolean) => void;
  onSend: (props: { messageHTML: string; rawMessage: string }) => void;
  onUpload: (files: []) => void;
  subject?: string;
  fromEmail?: { value: string; label: string };
  previousMessage?: EmailEntry;
  isReply?: boolean;
  editorHeight?: string;
  setSubject?: (subject: string) => void;
  setFromEmail?: (fromEmail: { value: string; label: string }) => void;
};

const ComposeEmailForm = ({
  projectId,
  toRecipients,
  ccRecipients,
  files,
  subject,
  isSubmitEnabled,
  emailSignature,
  uploaderId,
  editorHeight = '100%',
  isReply = false,
  previousMessage = null,
  fromEmail = null,
  onSend,
  setSubject,
  onUpload,
  setToRecipients,
  setCcRecipients,
  setHasInput,
  setIsUploading,
  setFromEmail = null,
}: ComposeEmailFormProps) => {
  return (
    <>
      <EmailHeadingInput
        isReply={isReply}
        projectId={projectId}
        ccRecipients={ccRecipients}
        toRecipients={toRecipients}
        fromEmail={fromEmail}
        subject={subject}
        setSubject={setSubject}
        setCcRecipients={setCcRecipients}
        setToRecipients={setToRecipients}
        setFromEmail={setFromEmail}
      />

      <EmailEditor
        files={files}
        submitEnabled={isSubmitEnabled}
        previousMessage={previousMessage}
        emailSignature={emailSignature}
        uploaderId={uploaderId}
        setHasInput={setHasInput}
        onUpload={onUpload}
        onUploading={setIsUploading}
        onSend={onSend}
        editorInitConfig={{
          height: editorHeight,
        }}
      />
    </>
  );
};

export default ComposeEmailForm;
